import { Stack } from "@mui/material";
import Reference from "../../common/Reference";
import Section from "../../common/Section/Section";
import { SectionComponentProps } from "../../types";
import NarrativeReferenceImage1 from "../references/narrative-1.png";
import NarrativeReferenceImage2 from "../references/narrative-2.png";
import { buildStoryNarrativeFields } from "../../../fields/narrative";

function ProjectNarratives({ details, onEdit }: SectionComponentProps) {
  const { narrative } = details;

  return (
    <Section
      title="Project Narratives"
      columns={1}
      fields={buildStoryNarrativeFields(narrative)}
      onEdit={() => onEdit("project-narratives")}
      reference={[
        {
          type: "image",
          place: "beneath",
          index: 0,
          item: (
            <Stack direction="row">
              <Reference
                image={NarrativeReferenceImage1}
                radius="25px"
                alt="Narratives reference 1"
                testId="narratives-reference-1"
              />
              <Reference
                image={NarrativeReferenceImage2}
                radius="25px"
                alt="Narratives reference 2"
                testId="narratives-reference-2"
              />
            </Stack>
          ),
        },
      ]}
    />
  );
}

export default ProjectNarratives;
